//
//
//
//
//
//
var script = {
  name: 'Blanket',
  props: {
    zIndex: {
      type: Number,
      default: 999
    }
  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Modal/Blanket.vue_rollup-plugin-vue=script.js